/*
 * File: WithTheme.tsx
 * Project: a-a
 * File Created: Tuesday, 8th October 2024 8:23:46 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 8th October 2024 8:28:57 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { CssBaseline } from '@mui/material';
import { Theme } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

export default (theme: Theme, Component: any, isBaseline = false): FC => {
  const baselineComponent = isBaseline ? <CssBaseline /> : <></>;
  // eslint-disable-next-line react/display-name
  return (props: object): ReactElement => (
    <ThemeProvider theme={theme}>
      {baselineComponent}
      <Component {...props} />
    </ThemeProvider>
  );
};